// extracted by mini-css-extract-plugin
module.exports = {"redirectPageWrapper":"redirect_redirectPageWrapper__1TlE_"};